<!-- 마이보드 > 마이보드 리스트 -->
<template>
  <div class="tabCont page1">
    <div class="p-inner top">
      <div class="tit-group02">
        <h2 class="tit">{{t('message.quickKPI')}}</h2>
        <p class="txt">{{infoText}}</p>
        <div class="area-r">
          <c-InputDate v-model="monthDate" :enableTimePicker="false" readonly="" name="monthDate" :isMonth="true" :formatType="'yyyy-MM'" />
        </div>
      </div>
      <div class="card-group02 ty04">
        <div class="card-col ty03" v-if="pageType=='1'">
          <div class="icon ico3" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ allCnt }}</div>
            <div class="txt2">{{t('message.allReceivedCorrectiveActions')}}</div>
          </div>
        </div>
        <div class="card-col ty03" v-if="pageType=='1'">
          <div class="icon ico4" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ completeCnt }}</div>
            <div class="txt2">{{t('message.complete')}}</div>
          </div>
        </div>
        <div class="card-col ty03" v-if="pageType=='1'">
          <div class="icon ico5" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ ingCnt }}</div>
            <div class="txt2">{{t('message.inProgress')}}</div>
          </div>
        </div>
        <div class="card-col ty03" v-if="pageType=='1'">
          <div class="icon ico6" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ delayCnt}}</div>
            <div class="txt2">{{t('message.onHold')}}</div>
          </div>
        </div>
        <div class="card-col ty03" v-if="pageType=='1'">
          <div class="icon ico7" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ preparingCnt }}</div>
            <div class="txt2">{{t('message.statusPreparing')}}</div>
          </div>
        </div>
        <div class="card-col ty03" v-if="pageType=='2'">
          <div class="icon ico3" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ receiveGoodCnt }}</div>
            <div class="txt2">{{t('message.receivedAllPraise')}}</div>
          </div>
        </div>
        <div class="card-col ty03" v-if="pageType=='2'">
          <div class="icon ico3" aria-hidden="true"></div>
          <div class="txt-group">
            <div class="txt1">{{ sendGoodCnt }}</div>
            <div class="txt2">{{t('message.sentAllPraise')}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-inner">
      <div class="tit-group02">
        <h2 class="tit">{{tabType=='tabCont1'||tabType=='tabCont2'?t('message.receivedCorrectiveActions'):t('message.receivedPraise')}}</h2>
        <c-btnLine01 :btnText="t('message.seeMore')" class="sm" @click="onClickView('receive')"/>
      </div>
      <div class="content-box">
        <div class="tbl-group" :class="pageType == '1' ?'size-custom5': 'size-custom5-2'">
          <v-data-table
            :headers="headers"
            :items="receiveItems"
            hide-default-footer
            return-object
          >
            <template v-slot:item="{ item, index }">
              <tr class="v-data-table__tr" @click="utils.movePage('/myBoardDetail/'+item.idx)">
                <td>{{index+1}}</td>
                <td>
                  <div class="ell01">
                    {{item.situation}}
                  </div>
                </td>
                <td>
                  <div :class="getColor(item.goalDate)">
                    {{item.goalDate}}
                  </div>
                </td>
                <td>{{item.memberName}}</td>
                <td>{{item.targetText}}</td>

                <td v-if="pageType == '1'">
                  <div :class="getColor2(item.status)">
                    {{item.statusText}}
                  </div>
                </td>
                <td>
                  <div class="dv1">
                    <div class="ico" :class="getColor2(item.status)">
                      {{item.statusText}}
                    </div>
                    <div class="ell01">
                      {{item.situation}}
                    </div>
                  </div>
                  <div class="dv2">
                    <div :class="getColor(item.goalDate)">
                      {{item.goalDate}}
                    </div>
                    &nbsp;/ {{item.memberName}} / {{item.targetText}}
                  </div>
                </td>
                <td>{{item.modDateFormat}}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <div class="p-inner">
      <div class="tit-group02">
        <h2 class="tit">{{tabType=='tabCont1'||tabType=='tabCont2'?t('message.issuedCorrectiveActions'):t('message.sentPraise')}}</h2>
        <c-btnLine01 :btnText="t('message.seeMore')" class="sm" @click="onClickView('send')"/>
      </div>
      <div class="content-box">
        <div class="tbl-group" :class="pageType == '1' ?'size-custom5': 'size-custom5-2'">
          <v-data-table
            :headers="headers"
            :items="sendItems"
            hide-default-footer
            return-object
          >
            <template v-slot:item="{ item, index }">
              <tr class="v-data-table__tr" @click="utils.movePage('/myBoardDetail/'+item.idx)">
                <td>{{index + 1}}</td>
                <td>
                  <div class="ell01">
                    {{item.action}}
                  </div>
                </td>
                <td>
                  <div :class="getColor(item.goalDate)">
                    {{item.goalDate}}
                  </div>
                </td>
                <td>{{item.memberName}}</td>
                <td>{{item.targetText}}</td>

                <td v-if="pageType == '1'">
                  <div :class="getColor2(item.status)">
                    {{item.statusText}}
                  </div>
                </td>
                <td>
                  <div class="dv1">
                    <div class="ico" :class="getColor2(item.status)" v-if="pageType=='1'">
                      {{item.statusText}}
                    </div>
                    <div class="ell01">
                      {{pageType=='1'?item.action:item.situation}}
                    </div>
                  </div>
                  <div class="dv2">
                    <div :class="getColor(item.goalDate)" v-if="pageType=='1'">
                      {{item.goalDate}} /
                    </div>
                    &nbsp;{{item.memberName}} / {{item.targetText}}
                  </div>
                </td>
                <td>{{item.modDateFormat}}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
  </div>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import { useCommonStore } from "@/store/common";
import {storeToRefs} from "pinia";
import TimelineService from "@/services/timeline.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//1:나의시정 2:부서시정 3:나의칭찬 4:부서칭찬
const props = defineProps(['tabType'])
const pageType = (props.tabType == 'tabCont1' || props.tabType == 'tabCont2')?'1':'2'
//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const completeCnt = ref(0)
const ingCnt = ref(0)
const delayCnt = ref(0)
const preparingCnt = ref(0)
const badCnt = ref(0)
const goodCnt = ref(0)
const allCnt = ref(0)
const receiveGoodCnt = ref(0)
const sendGoodCnt = ref(0)
const receiveItems:any = ref([])
const sendItems:any = ref([])
const infoText = ref('')
const monthDate = ref(dayjs().format('YYYY-MM'))

//ui
const headers = computed(() => {
  const baseHeaders = [
    {title: t('message.orderNumber'), key: 'idx'},
    {title: pageType == '1' ? t('message.correctiveActionDetails') : t('message.safetyTalk'), key: 'situation'},
    {title: t('message.actionDeadlineInBoard'), key: 'goalDate'},
    {title: t('message.author'), key: 'memberName'},
    {title: t('message.targetPersonInBoard'), key: 'targetText'},
    {title: t('message.progressStatus'), key: 'statusText'},
    {title: pageType == '1' ? t('message.correctiveActionSummary') : t('message.praiseActionSummary'), key: 'moDate'},
    {title: t('message.registrationDate'), key: 'modDateFormat'},
  ]


  if(pageType == '2')
    return baseHeaders.filter(header => header.key !== 'statusText')
  else
    return baseHeaders
})


//hook
onMounted(() => {
  onClickSearch()
})

onUpdated(() => {
  if(props.tabType == 'tabCont1')
    infoText.value = t('message.basedOnMyReceivedCorrectiveActions')
  else if(props.tabType == 'tabCont2')
    infoText.value = t('message.basedOnTeamReceivedCorrectiveActions')
  else if(props.tabType == 'tabCont3')
    infoText.value = t('message.basedOnMyReceivedInCorrectiveActions')
  else if(props.tabType == 'tabCont4')
    infoText.value = t('message.basedOnTeamReceivedInCorrectiveActions')
})

//function
const onClickSearch=()=>{
  const tab = storeRef.tabName.value
  const curTab = props.tabType
  if(tab != curTab)
    return

  const user = JSON.parse(localStorage.getItem('user'))
  const companyIdx = localStorage.getItem('companyIdx')
  let memberIdx = user.memberIdx
  let deptIdx = user.deptIdx
  //1,3은 개인 2,4는 부서
  if(props.tabType == 'tabCont1' || props.tabType == 'tabCont3')
    deptIdx = 0
  else
    memberIdx = 0

  let params = {
    memberIdx:memberIdx,
    deptIdx:deptIdx,
    companyIdx:companyIdx,
    startDate : dayjs(monthDate.value).startOf('month').format('YYYY-MM-DD'),
    endDate : dayjs(monthDate.value).endOf('month').format('YYYY-MM-DD'),
  }
  TimelineService.getTimelineSummary(params).then(
    (response:any) => {
      //summary 갯수
      const totalReceive = response.result.receiveTimelines
      badCnt.value = _.filter(totalReceive, {type:'1'}).length
      goodCnt.value = _.filter(totalReceive, {type:'2'}).length
      //1,2탭은 교정, 3,4탭은 지지적
      //const pageType = (props.tabType == 'tabCont1' || props.tabType == 'tabCont2')?'1':'2'
      allCnt.value = pageType=='1' ? badCnt.value : goodCnt.value
      //각 숫자는 교정, 지지적으로 분리됐음
      completeCnt.value = _.filter(totalReceive, {type:pageType, status:'4'}).length
      delayCnt.value = _.filter(totalReceive, {type:pageType, status:'3'}).length
      ingCnt.value = _.filter(totalReceive, {type:pageType, status:'2'}).length
      preparingCnt.value = _.filter(totalReceive, {type:pageType, status:'1'}).length
      //안전대화, 지지적 분리
      receiveItems.value = _.filter(response.result.receiveTimelines, {type:pageType})
      receiveGoodCnt.value = receiveItems.value.length
      //받은목록 5개까지만
      receiveItems.value = _.slice(receiveItems.value, 0, 5)
      //상세데이터 변경
      _.forEach(receiveItems.value, (val, key)=> {
        val.actionYnText = val.actionYn=='Y'?t('message.necessary'):t('message.notNecessary')
        val.targetText = t('message.none')
        if(val.targetType == '2') val.targetText = val.targetDeptName
        else if(val.targetType == '3') val.targetText = val.targetMemberName
        val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(val.goalDate).format('YYYY-MM-DD')
        val.statusText = t('message.ready')
        if(val.status == '2')
          val.statusText = t('message.inProgress')
        else if(val.status == '3')
          val.statusText = t('message.onHold')
        else if(val.status == '4')
          val.statusText = t('message.complete')
      })
      //보낸목록 5개까지만
      sendItems.value = _.filter(response.result.sendTimelines, {type:pageType})
      sendGoodCnt.value = sendItems.value.length
      sendItems.value = _.slice(sendItems.value, 0, 5)
      _.forEach(sendItems.value, (val, key)=> {
        val.actionYnText = val.actionYn=='Y'?t('message.necessary'):t('message.notNecessary')
        val.targetText = t('message.none')
        if(val.targetType == '2') val.targetText = val.targetDeptName
        else if(val.targetType == '3') val.targetText = val.targetMemberName
        val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(val.goalDate).format('YYYY-MM-DD')
        val.statusText = t('message.ready')
        if(val.status == '2')
          val.statusText = t('message.inProgress')
        else if(val.status == '3')
          val.statusText = t('message.onHold')
        else if(val.status == '4')
          val.statusText = t('message.complete')
      })
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickView=(type)=>{
  //receive, send
  storeRef.senderType.value = type
  storeRef.isTabView1.value = true
}
const getColor=(goalDate)=> {
  const startDate = dayjs()
  const endDate = dayjs(goalDate)
  const duration = endDate.diff(startDate, 'days')
  if (duration < 7)
    return 'txt-red'
}
const getColor2=(status)=> {
  if (status == '1') return 'txt-yellow'
  else if (status == '2') return 'txt-blue'
  else if (status == '3') return 'txt-orange'
  else if (status == '4') return 'txt-green'
}

//watch
watch(monthDate, (newObj) => {
  onClickSearch()
})

//expose
//부모창에서 실행할 수 있는함수.. 아직 사용안함
defineExpose({onClickSearch});
</script>


<style lang="scss" >
</style>
